<template>
    <div class="col-sm-8 col-sm-offset-2 panel-signin">
      <div class="panel panel-default" style="height: 350px">
          <div class="panel-body" style="height: 350px; padding: 0px">
              <b-row>
                  <div class="col-xs-12 col-sm-4">
                      <div class="form-signin">  
                          <div class="text-left">
                              <h2>Login</h2>
                          </div>
                          <div class="text-helper">
                              Welcome. Please fill username and password to sign in into your account
                              <span v-if="invalidLogin" class="text-helper text-danger"><br/>Invalid username or password</span>
                          </div>
                          <div v-if="(useSso == true ? false : true)">
                              <b-form-input id="input-username" placeholder="Username" v-model="username" size="sm" @keyup.enter="login"></b-form-input>
                              <b-input type="password" id="input-password" placeholder="Password" class="mt-3" v-model="password" size="sm" @keyup.enter="login"></b-input>
                          </div>
                          <div v-else class="mt-5">
  
                          </div>
                            <button class="btn btn-default btn-md" @click="login" :disabled="loginBusy">
                                <span v-if="!loginBusy">Login</span>
                                <span v-else>
                                    <b-spinner variant="light" label="Spinning" small></b-spinner>
                                </span>
                            </button>
                      </div>
                  </div>
                  <div class="col-sm-8 panel-background d-sm-none d-md-flex" style="border-left: 1px solid #ddd;height: 350px;"></div>
              </b-row>
          </div>
      </div>
  </div>
  </template>
  <style lang="scss" scoped>
      .col-sm-offset-2 {
  
      }
      #own_login {
          margin-top: 100px;            
      }
      #own_icon {
          text-align: center;
      }
      #own_icon span {
          font-size: 40pt;            
          padding: 15px;
          color: #dadada;
          border: 5px solid #dadada;
          border-radius: 100%;
      }
      button {
          width: 100%;
      }
      small {
          color: #777;
      }
      h2 {
          color: #717171;
          margin-bottom: 15px;
      }
      
      .form-signin {
          max-width: 330px;
          padding: 15px;
          margin: 0 auto;
          padding-top: 30px;
          background-color: #fff;
      }
      .form-signin .form-signin-heading,
      .form-signin .checkbox {
          margin-bottom: 10px;
      }
      .form-signin .checkbox {
          font-weight: normal;
      }
      .form-signin .form-control {
          position: relative;
          height: auto;
          -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
                  box-sizing: border-box;
          padding: 7px;
          font-size: 13px;
      }
      .form-signin .form-control:focus {
          z-index: 2;
      }
      .form-signin input[type="email"] {
          margin-bottom: -1px;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
      }
      .form-signin input[type="password"] {
          margin-bottom: 15px;
      }
  
      button.btn-default,
      a.btn-default {
          color: #fff;
          border-color: #787878;
      }
      button.btn-default:hover,
      button.btn-default:focus,
      a.btn-default:hover,
      a.btn-default:focus {
          color: #fff;
          border-color: #787878;
      }
      .panel-background {
          background: url('/img/background_computer.jpeg');
          background-repeat: no-repeat;
          border-bottom-right-radius: 2px;
          border-top-right-radius: 2px;
          overflow: hidden !important;
      }
      @media (min-width: 768px) {
          .panel-background {
              background-size: 160% auto;
              background-position: -100px;
          }
      }
      @media (min-width: 980px) {
          .panel-background {
              background-size: 126% auto;
              background-position: -80px;
          }
      }
      @media (min-width: 1270px) {
          .panel-background {
              background-size: 102% auto;
              background-position: -1px;
          }
      }
      body {
          font-family: Arial, sans-serif;
      }
      #inputUser {
          margin-bottom: 5px;
      }
      .text-helper {
          font-size: 12px;
          margin-bottom: 20px;
          color: #afafaf;
      }
      .panel {
          background: #fff;
          -webkit-box-shadow: 10px 21px 74px -30px rgba(115,115,115,1);
          -moz-box-shadow: 10px 21px 74px -30px rgba(115,115,115,1);
          box-shadow: 10px 21px 74px -30px rgba(115,115,115,1);
      }
      @media (min-width: 768px) { 
          body {
              background-color: #efefef;
          }
      }
      .panel-signin {
          margin-top: 100px;
          padding-bottom: 100px;
      }
      @media (min-height: 700px) { 
          .panel-signin {
              margin-top: 190px;
          }
      }

      @media (min-width: 576px) { 
          .panel-signin {
            margin-left: 16.66666667%;
          }
      }
  
     ::v-deep .front-page {
          background: #fff url('/img/bg-yard-grayscaled.jpg') no-repeat center center / cover;
          height: 100%;
          left: 0;
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 1000;
  
          .card {
              background-color: white;
              box-shadow: 0 1px 20px #000;
              left: 50%;
              min-width: 260px;
              max-width: 500px;
              position: absolute;
              text-align: center;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 80%;
          }
  
          .card-body {
              padding-right: 0px;
              padding-left: 0px;
          }
  
          .text {
              padding: 30px 30px 20px 30px;
  
              .division {
                  color: #555;
                  font-size: 24px;
                  font-weight: bold;
                  margin-top: 20px;
                  position: relative;
  
                  &:before {
                      position: absolute;
                      top: -5px;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 50px;
                      height: 1px;
                      background-color: rgba(100, 100, 100, 0.5);
                      content: "";
                  }
              }
  
              img {
                  display: block;
                  margin: 0 auto;
                  height: 100px;
              }
  
              .error-login {
                  border-width:medium;
                  font-size:medium;
                  color: #CC0400;
                  text-align: center;
                  border:solid;
                  border-color: red;
              }
  
              .error {
                  color: #CC0400;
                  text-align: left;
              }
          }
  
          .form-login {
              background: #BF0400;
              padding: 20px;
          }
          .action-button {
              .btn-danger {
                  color: #fff;
                  font-weight: 600;
                  background-color: #BF0400;
                  border-color: #BF0400;
              }
              .btn-danger:active, .btn-danger:focus, .btn-danger:hover {
                  background-color: #a50602 !important;
                  border-color: #a50602 !important;
              }
          }
      }
  </style>
  <script>
  import Role from '@/models/Core/Role';
  import { mapGetters } from 'vuex';
  
  export default {
      components : {},
      name: 'Login',
      data() {
        return {
          username : "",
          password : "",
          token : "",
          loginFailed: false,
          loginBusy: false,
          model: {},
          useSso: false,
          invalidLogin: false,
        }
      },
      computed: {
          ...mapGetters({
              accessToken: 'accessToken',
              isLoggedIn: 'isLoggedIn',
              user: 'user'
          })
      },
      methods: {
          login() {
            let frm = {
                userName: this.username,
                password: this.password
            }
            this.dologin(frm)
          },
          dologin(model) {
            this.loginBusy = true;
            this.$store.dispatch('login', model)
                .then(response => {
                    this.loginFailed = false;
                    this.getUserRole();
                }).catch(error => {
                    this.loginFailed = true;
                    this.loginBusy = false;
                    this.username = '';
                    this.password = '';
                    this.invalidLogin = true;
                    // this.$store.dispatch('addErrorMessageGlobal', error);
                });
          },
          async getUserRole() {
            if (this.$store.getters.isLoggedIn == true) {
                if (this.accessToken != null && this.accessToken != undefined && this.accessToken != "") {
                    let this_ = this;
                    Role.getMe(this).then(result => {
                        this.$store.dispatch('setRoleLoaded');
                        this.$store.dispatch('get_userinfo');
                        this.loginBusy = false;
                        this.$router.replace({ name: 'homeindex' });
                    }).catch(function (error) {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this_.loginBusy = false;
                                this_.logout();
                            } else {
                                this_.loginBusy = false;
                                this_.logout();
                                this_.$store.dispatch('addErrorMessageGlobal', error);
                            }
                        } else {
                            this_.loginBusy = false;
                            this_.logout();
                            this_.$store.dispatch('addErrorMessageGlobal', error);
                        }
                    });
                } else {
                    this.loginBusy = false;
                }
            } else {
                this.loginBusy = false;
            }
        },
        logout() {
            this.$store.dispatch('logout').then(()=>{});
        }
      },
  }
  </script>